import { errorToast } from "@/v2-ui/toast"
import { useTenantMultiSessionMutation } from "@/v2-backoffice-client/tenant/multiSession/tenant.multiSession.mutation"
import ActionMenu from "@/v2-backoffice-client/components/actionMenu"

export type TenantMultiSessionMenuProps = {
  tenantId: number
  onCompleted?(): void
}

function TenantMultiSessionMenu(props: TenantMultiSessionMenuProps) {
  const { tenantId, onCompleted } = props

  const [setMultiSession, { loading, error }] = useTenantMultiSessionMutation()
  errorToast(error, { title: "Failed to update multi-session exemption" })

  return (
    <ActionMenu>
      <ActionMenu.Trigger
        isStacked
        iconSrc="devices"
        content="Exempt every user of this team from the single-active-session limit, or re-subject them to it."
      >
        Multi-Session
      </ActionMenu.Trigger>

      <ActionMenu.Content>
        <ActionMenu.Label>Multi-Session</ActionMenu.Label>
        <ActionMenu.Separator />

        <ActionMenu.ConfirmItem
          iconSrc="unlock"
          variant="success"
          content="Exempt every user of this tenant from the single-active-session limit."
          confirmDescription="Allow multi-session for all users of this tenant?"
          confirmVariant="success"
          isLoading={loading}
          onConfirm={() => {
            setMultiSession({
              variables: { tenantId, allowed: true },
              onCompleted,
            })
          }}
        >
          Allow for all users
        </ActionMenu.ConfirmItem>

        <ActionMenu.ConfirmItem
          iconSrc="lock"
          variant="warning"
          content="Re-subject every user of this tenant to the single-active-session limit."
          confirmDescription="Disallow multi-session for all users of this tenant?"
          confirmVariant="warning"
          isLoading={loading}
          onConfirm={() => {
            setMultiSession({
              variables: { tenantId, allowed: false },
              onCompleted,
            })
          }}
        >
          Disallow for all users
        </ActionMenu.ConfirmItem>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default TenantMultiSessionMenu
